module.exports = __webpack_public_path__ + "static/media/footer-trans@2x.603d40c3.png";